<template>
  <el-dialog v-if="visible" title="导入数据" class="avue-dialog avue-dialog--top" width="550px" append-to-body
    destroy-on-close :close-on-click-modal="false" :visible.sync="visible">
    <avue-form :option="option" v-model="form" v-loading="loading">
      <template #upload>
        <el-upload action="" accept=".xls,.xlsx" :limit="1" :auto-upload="false" :file-list="fileList"
          :on-change="onUpload">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">导入文件不能超过5M，仅允许导入“xls”或“xlsx”格式文件！</div>
        </el-upload>
      </template>
    </avue-form>
    <div class="avue-dialog__footer">
      <el-button type="primary" @click="downloadTemplate">下载模板</el-button>
      <el-button type="primary" :loading="loading" @click="onSubmit">确定</el-button>
      <el-button @click="visible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { exportTrainTemplate, importTrainTemplate } from "@/api/handover-inspection/passing-manage";
import { downloadXls, jsonToFormData } from "@/util/util";

export default {
  name: "train-import",
  props: ['isHGZ'],
  data() {
    return {
      visible: false,
      loading: false,
      form: {},
      fileList: [],
      option: {
        span: 24,
        menuBtn: false,
        filterDic: true,
        filterNull: true,
        column: [
          {
            label: '过车时间',
            prop: 'importTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss'
          },
          {
            label: "股道",
            prop: "poundno",
            type: "select",
            dicUrl: `${this.baseDicUrl}/${this.isHGZ ? 'hgz_poundno_code' : 'jtg_poundno_dx'}`,
            props: this.dicProps,
            filterable: true,
            value: this.isHGZ ? '001' : '002',
            clearable: false,
            rules: [
              {
                required: true,
                message: "请选择股道",
                trigger: "blur",
              }
            ]
          },
          {
            label: '来车方向',
            prop: 'direction',
            type: 'select',
            dicUrl: `${this.baseDicUrl}/direction`,
            props: this.dicProps,
            filterable: true,
            value: '3',
            clearable: false,
          },
          {
            label: '附件',
            prop: 'upload',
          },
        ]
      }
    }
  },
  methods: {
    // 上传文件
    onUpload(file) {
      if (file.size > 5 * 1024 * 1024) {
        this.$message.error('导入文件不能超过5M')
        this.fileList = []
      } else {
        this.fileList = [file]
      }
    },
    onSubmit() {
      if (!this.form.importTime) {
        this.$message.error('请选择过车时间')
        return
      }
      if (!this.fileList.length) {
        this.$message.error('请上传附件')
        return
      }
      const params = jsonToFormData({ ...this.form, file: this.fileList[0].raw })
      this.loading = true
      importTrainTemplate(params).then(res => {
        if (res.code === 200) {
          this.$message.success(res.msg)
          this.$emit('afterImport')
          this.visible = false
        }
      }).finally(() => {
        this.loading = false
      })
    },
    downloadTemplate() {
      exportTrainTemplate().then(res => {
        downloadXls(res, '火车车厢信息导入模板.xlsx')
      })
    }
  },
  watch: {
    visible(val) {
      if (!val) {
        Object.assign(this.$data, this.$options.data.call(this))
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
